<template>
  <div class="app-container">
    <el-card shadow="hover">
      <!-- 查询和其他操作 -->
      <div class="filter-container">
        <el-input v-model="listQuery.name" clearable class="filter-item" style="width: 200px;" placeholder="请输入指标名称" />
        <el-select v-model="listQuery.labelType" clearable style="width: 200px" class="filter-item" placeholder="请选择指标类型">
          <el-option v-for="type in typeOptions" :key="type.value" :label="type.label" :value="type.value" />
        </el-select>
        <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
        <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreate(null)">添加</el-button>
      </div>

      <!-- 查询结果 -->
      <el-table v-loading="listLoading" :data="list" element-loading-text="正在查询中。。。" border fit highlight-current-row row-key="id">

        <el-table-column align="left" label="指标名称" prop="name" width="300px" />

        <el-table-column align="center" label="类型" prop="type">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type==0 ? 'success' : 'error' ">{{ scope.row.type | formatType }}</el-tag>
          </template>
        </el-table-column> 

       <el-table-column align="center" label="是否设置过脚本" prop="isSetSql">
          <template slot-scope="scope">
            {{scope.row.level==2&&scope.row.isSetSql?'已设置':(scope.row.level!=2?'':'未设置')}}
          </template>
        </el-table-column>
        
        <el-table-column align="center" label="指标" prop="goal">
          <template slot-scope="scope">
            {{ scope.row.goal }}{{scope.row.property=='percent'?'%':''}}
          </template>
        </el-table-column>
 

        <el-table-column align="center" label="状态" prop="deleted">
          <template slot-scope="scope">
            <el-tag :type="scope.row.deleted ? 'success' : 'error' ">{{ scope.row.deleted ? '不启用' : '启用' }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="备注" prop="remark" show-overflow-tooltip="true" />

        <el-table-column align="center" label="操作" width="300" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button v-show="scope.row.level!=2" icon="el-icon-plus" type="text" size="mini" @click="handleCreate(scope.row)">新增下一级</el-button>
            <el-button icon="el-icon-edit" type="text" size="mini" @click="handleUpdate(scope.row)">编辑</el-button>
            <el-button style="color:red" icon="el-icon-close" type="text" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

      <!-- 添加或修改对话框 -->
      <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="750px">
        <el-form ref="dataForm" :rules="rules" :model="dataForm" status-icon label-position="left" label-width="120px" style="width: 600px; margin-left:50px;">
          <el-form-item label="上级指标名称" v-show="dataForm.parentName!=null" prop="parentName">
            <span style="color:#09afff">{{dataForm.parentName}}</span>
          </el-form-item>

          <el-form-item label="指标名称" prop="name">
            <el-input v-model="dataForm.name" placeholder="指标名称" />
          </el-form-item>  

          <el-form-item v-show="dataForm.level === 2" label="标签类型" prop="type">
            <el-radio-group v-model="dataForm.type">
              <el-radio v-for="item in typeOptions" :key="item.value" :label="item.value" :value="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-show="dataForm.level === 2" label="指标SQL" prop="tSql">
            <el-input v-model="dataForm.tSql" rows="8" placeholder="符合指标的sql语句 如：select curr_date,station_id,worker_no,num,den,value from customer_client;其中curr_date：日期,station_id：服务站id,worker_no：服务者,num：除数（分子),den：被除数（分母）,value：指标项" type="textarea" />
          </el-form-item>

          <el-form-item v-show="dataForm.level === 2" label="指标属性" prop="property">
            <el-radio-group v-model="dataForm.property"> 
              <el-radio label="int">数值</el-radio>
              <el-radio label="percent">百分比</el-radio> 
            </el-radio-group>
          </el-form-item>

          <el-form-item v-show="dataForm.level === 2" label="标签目标值" prop="labelGoal">
            <el-input v-model="dataForm.goal" placeholder="达标值 如果是百分比50% 请填写50" type="number" />
          </el-form-item> 

          <el-form-item label="备注" prop="remark">
            <el-input v-model="dataForm.remark" />
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确定</el-button>
          <el-button v-else type="primary" @click="updateData">修改</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>


<script>
import service from "@/script/api/workercrmapi";
import Pagination from "@/components/common/Pagination";

const defaultTypeOptions = [
  {
    label: "服务者标签",
    value: 0,
  },
  {
    label: "驿站标签",
    value: 1,
  }, 
  // {
  //   label: "城市标签",
  //   value: 2,
  // },
];

const defaultFrequencyOptions = [
  {
    label: "每日一次",
    value: 0,
  }, 
  // {
  //   label: "每10分钟一次",
  //   value: 1,
  // },
];
const defaultDateDimOptions = [
  {
    label: "日维度数据",
    value: 0,
  },
  {
    label: "月维度数据",
    value: 1,
  },
  {
    label: "实时数据",
    value: 2,
  },
  {
    label: "不变数据",
    value: 3,
  }
];

export default {
  name: "targetSetting",
  components: { Pagination },
  filters: {
    formatType(type) {
      for (let i = 0; i < defaultTypeOptions.length; i++) {
        if (type === defaultTypeOptions[i].value) {
          return defaultTypeOptions[i].label;
        }
      }
      return "分类";
    },
    formatDateDim(dim) {
      for (let i = 0; i < defaultDateDimOptions.length; i++) {
        if (dim === defaultDateDimOptions[i].value) {
          return defaultDateDimOptions[i].label;
        }
      }
      return "无";
    },
  },
  data() { 
    const validateSql = (rule, value, callback) => {
      if (
        this.dataForm.labelType == 0 &&
        this.dataForm.labelLevel == 2 &&
        (value == "" || value == undefined || value == null)
      ) {
        callback(new Error("请输入标签SQL"));
      } else {
        callback();
      }
    };
    const validateType = (rule, value, callback) => {
      if (
        this.dataForm.labelType == 2 &&
        (value == "" || value == undefined || value == null)
      ) {
        callback(new Error("请选择标签类型"));
      } else {
        callback();
      }
    };
    const validateProperty = (rule, value, callback) => {
      if (
        this.dataForm.labelType == 2 &&
        (value == "" || value == undefined || value == null)
      ) {
        callback(new Error("请选择标签属性"));
      } else {
        callback();
      }
    };
    return {
      typeOptions: Object.assign({}, defaultTypeOptions),
      frequencyOptions: Object.assign({}, defaultFrequencyOptions),
      dateDimOptions: Object.assign({}, defaultDateDimOptions),
      list: [],
      keywords: [], //枚举值集合
      newKeywordVisible: false,
      newKeyword: "",
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined,
        labelType: undefined,
        deleted: undefined,
        sort: "create_time",
        order: "desc",
      },
      dataForm: {
        id: undefined,
        level: 0, 
        deleted: false,
        name: undefined,
        type: 0,
        property: undefined,
        tSql: undefined,
        parentName: "一级标签",
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑标签",
        create: "创建标签",
      },
      rules: { 
        name: [
          { required: true, message: "标签标题不能为空", trigger: "blur" },
        ],
        type: [
          {
            validator: validateType,
            required: true,
            message: "标签类型不能为空",
            trigger: "blur",
          },
        ],
        property: [
          {
            validator: validateProperty,
            required: true,
            message: "列属性不能为空",
            trigger: "blur",
          },
        ],
        tSql: [{ validator: validateSql, required: true, trigger: "blur" }],
      },
      downloadLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      service
        .$axiosDimTargetList(this.listQuery)
        .then((response) => {
          this.list = response.data.data;
          console.info(this.list);
          //this.total = response.data.data.total
          this.listLoading = false;
        })
        .catch(() => {
          this.list = [];
          this.listLoading = false;
        });
    },
    handleCategoryChange(value) {
      this.dataForm.labelCategory = value[value.length - 1];
    },
    handleTypeChange(value) {
      console.info(value);
      if (value == 1) {
        this.dataForm.labelProperty = "string";
        this.dataForm.labelSql = "";
      }
    },
    handleClose(tag) {
      this.keywords.splice(this.keywords.indexOf(tag), 1);
      this.dataForm.labelValue = this.keywords.toString();
    },
    showInput() {
      this.newKeywordVisible = true;
      this.$nextTick((_) => {
        this.$refs.newKeywordInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      const newKeyword = this.newKeyword;
      if (newKeyword) {
        this.keywords.push(newKeyword);
        this.dataForm.labelValue = this.keywords.toString();
      }
      this.newKeywordVisible = false;
      this.newKeyword = "";
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetForm() {
      this.dataForm = {
        id: undefined,
        level: 0,
        name: undefined,
        type: 0, 
        deleted: false, 
        parentName: "一级标签",
        tSql: undefined,
        property:'int',
        goal: "", 
      };
      this.keywords = [];
    },
    handleCreate(row) {
      this.resetForm();
      if (row != null) {
        console.info("row!=null");
        this.dataForm.level = row.level + 1; 
        this.dataForm.parentId = row.id;
        this.dataForm.parentName = row.name;
      }
      console.info(this.dataForm);
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    createData() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          service
            .$axiosDimTargetCreate(this.dataForm)
            .then((response) => {
              this.getList();
              this.dialogFormVisible = false;
              this.$notify.success({
                title: "成功",
                message: "创建标签成功，数据筛选大约在10分钟后完成",
              });
            })
            .catch((response) => {
              this.$notify.error({
                title: "失败",
                message: response.data.errmsg,
              });
            });
        }
      });
    },
    handleUpdate(row) {
      console.info(row);
      this.dataForm = {
        id: row.id,
        level: row.level,
        name: row.name,
        type: row.type, 
        tSql: row.sql, 
        property:row.property,
        goal: row.goal, 
        remark: row.remark,
      };
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });

      this.keywords = row.value == null ? [] : row.value.split(",");
    },
    updateData() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          service
            .$axiosDimTargetUpdate(this.dataForm)
            .then(() => {
              this.getList();
              this.dialogFormVisible = false;
              this.$notify.success({
                title: "成功",
                message: "更新优惠券成功",
              });
            })
            .catch((response) => {
              this.$notify.error({
                title: "失败",
                message: response.data.errmsg,
              });
            });
        }
      });
    },
    handleDelete(row) {
      service
        .$axiosDimTargetDelete(row)
        .then((response) => {
          this.$notify.success({
            title: "成功",
            message: "停用标签成功",
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        })
        .catch((response) => {
          this.$notify.error({
            title: "失败",
            message: response.data.errmsg,
          });
        });
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.el-button--text {
  padding: 0 !important;
  width: auto !important;
  margin-left: 5px !important;
}
.el-button--text span {
  margin-left: 0px !important;
}
</style>